import { Button } from '@consta/uikit/Button'
import { withTooltip } from '@consta/uikit/withTooltip'

import type {
  NavBarChoiceItemsType,
  VelocitySimulationGroup,
  VelocitySimulationItem,
} from './types'

export const layersMenuChoiceItems: NavBarChoiceItemsType[] = [
  {
    name: 'V инт',
    navLabel: 'Интервальные скорости',
    disabled: false,
  },
  {
    name: 'V ср',
    navLabel: 'Средние скорости',
    disabled: true,
  },
]

export const modelMenuChoiceItems: NavBarChoiceItemsType[] = [
  {
    name: 'Создать новую',
    navLabel: 'Создать новую',
    disabled: false,
  },
  {
    name: 'Пересчитать модель',
    navLabel: 'Пересчитать модель',
    disabled: false,
  },
]

export const MAX_SELECT_ITEM_LENGTH = 40

export const ButtonWithTooltip = withTooltip({
  direction: 'downCenter',
  appearTimeout: 300,
})(Button)

export const vsGroups: VelocitySimulationGroup[] = [
  { id: 'input', title: 'Входные данные' },
  { id: 'results', title: 'Результаты' },
]

export const vsItems: VelocitySimulationItem[] = [
  { id: 'model', groupId: 'input', label: 'Модель' },
  { id: 'layers', groupId: 'input', label: 'Слои' },
  { id: 'geometry', groupId: 'results', label: 'Геометрия' },
]
